import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Company } from "./Company";
/**
 * Company settings model
 */

export class CompanySettings extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getWorktime = () => {
      return this.model.worktime || [];
    };

    this.getWorktimeOrderProcessing = () => {
      return this.model.worktimeOrderProcessing || [];
    };

    this.getWorktimePickup = () => {
      return this.model.worktimePickup || [];
    };

    this.getWorktimeDelivery = () => {
      return this.model.worktimeDelivery || [];
    };

    this.getDeliveryReportEmails = () => {
      return this.model.deliveryReportEmails || [];
    };

    this.getDeliveryOrderLimits = () => {
      return this.model.deliveryOrderLimits || [];
    };

    this.getSalesReportEmails = () => {
      return this.model.salesReportEmails || [];
    };

    this.getDeliveryDelay = () => {
      return this.model.deliveryDelay;
    };

    this.getPickupDelay = () => {
      return this.model.pickupDelay;
    };

    this.getDeliveryCountryText = () => {
      return this.model.deliveryCountryText;
    };

    this.getContractNumber = () => {
      return this.model.contractNumber;
    };

    this.getDeferment = () => {
      return this.model.deferment;
    };

    this.getShippingPoint = () => {
      return this.model.shippingPoint;
    };

    this.getRemainingDefermentEmails = () => {
      return this.model.remainingDefermentEmails || [];
    };

    this.getRegistrationCertificate = () => {
      return this.model.registrationCertificate;
    };

    this.getClubMembership = () => {
      return this.model.clubMembership;
    };

    this.getPaymentAccount = () => {
      return this.model.paymentAccount;
    };

    this.getAdditionalEmails = () => {
      return this.model.additionalEmails || [];
    };

    this.getAdditionalPhones = () => {
      return this.model.additionalPhones || [];
    };

    this.getSupplierCourier = () => {
      return this.model.supplierCourier || [];
    };

    this.getIsOrderAutoconfirm = () => {
      return this.model.isOrderAutoconfirm;
    };

    this.getPaidOn = () => {
      return this.model.paidOn;
    };

    this.getOrderDuplicateEmails = () => {
      return this.model.orderDuplicateEmails || [];
    };

    this.getDateRegistration = () => {
      return this.model.dateRegistration;
    };

    this.getFreeCntDelivery = () => {
      return this.model.freeCntDelivery;
    };

    this.getRealCntDelivery = () => {
      return this.model.realCntDelivery;
    };

    this.getFreeCntDeliveryRegion = () => {
      return this.model.freeCntDeliveryRegion;
    };

    this.getRealCntDeliveryRegion = () => {
      return this.model.realCntDeliveryRegion;
    };

    this.getFreeCntDeliveryCountry = () => {
      return this.model.freeCntDeliveryCountry;
    };

    this.getRealCntDeliveryCountry = () => {
      return this.model.realCntDeliveryCountry;
    };

    this.getParams = () => {
      return this.model.params;
    };

    this.getCompany = company => {
      return this.getRelation('company', Company, company);
    };
  }

  /**
   * Create company settings
   *
   * @param {object} object
   *
   * @return {Company}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * @inheritDoc
   */


  primaryKey() {
    return this.model.companyId;
  }
  /**
   * Get company worktime
   *
   * @return {Array.<object>}
   */


}